import React from "react";
import localeText from "../../../locale";

const ConfimeaBenefits = () => {
  const benefits = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="2" y="3" width="20" height="14" rx="2" />
          <path d="M8 21h8M12 17v4" />
        </svg>
      ),
      titleKey: "benefit1Title",
      textKey: "benefit1Text",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
      ),
      titleKey: "benefit2Title",
      textKey: "benefit2Text",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      ),
      titleKey: "benefit3Title",
      textKey: "benefit3Text",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 3v18h18" />
          <path d="M18 17V9M13 17V5M8 17v-3" />
        </svg>
      ),
      titleKey: "benefit4Title",
      textKey: "benefit4Text",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
        </svg>
      ),
      titleKey: "benefit5Title",
      textKey: "benefit5Text",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <path d="M14 2v6h6M9 15l2 2 4-4" />
        </svg>
      ),
      titleKey: "benefit6Title",
      textKey: "benefit6Text",
    },
  ];

  return (
    <section id="benefits" className="confimea-section confimea-section-gray">
      <div className="confimea-container">
        <div className="confimea-section-header flex flex-column gap-4">
          <div>
            <span className="confimea-section-badge">{localeText("benefitsBadge")}</span>
          </div>

          <div className="confimea-section-title">{localeText("benefitsTitle")}</div>
          <p className="confimea-section-subtitle">{localeText("benefitsSubtitle")}</p>
        </div>

        <div className="confimea-benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="confimea-benefit-card">
              <div className="confimea-benefit-icon">{benefit.icon}</div>
              <h3 className="confimea-benefit-title">{localeText(benefit.titleKey)}</h3>
              <p className="confimea-benefit-text">{localeText(benefit.textKey)}</p>
              <a href="#form" className="confimea-benefit-link">
                {localeText("benefitLink")}
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  width="16"
                  height="16"
                >
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </a>
            </div>
          ))}
        </div>

        <div className="confimea-info-banner">
          <div className="flex flex-column gap-2">
            <div className="confimea-info-banner-title">{localeText("benefitsInfoBannerText")}</div>
            <div className="confimea-info-banner-text">{localeText("benefitsInfoBannerText2")}</div>
          </div>

          <a href="#contact" className="confimea-btn confimea-btn-primary">
            {localeText("benefitsInfoBannerButton")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default ConfimeaBenefits;
